import { useEffect, useState } from "react"
import { FreeShippingOffers } from "../../storeApi"

// one request for the same cart, whoever asks (the seller headers and the footer)
let last = { key: "", promise: null }
const offersFor = (cart, key) => {
  if (last.key !== key) last = { key, promise: FreeShippingOffers(cart.map((line) => ({ pid: line.pid, quantity: line.quantity || 1 }))).then((result) => result?.offers || []).catch(() => []) }
  return last.promise
}

/**
 * What each seller in the cart gives free delivery at, asked for whenever the
 * cart's products change: [{ sellerName, met, remaining, currency }]. A seller
 * who makes no offer is not in the answer. null until it is known.
 */
export function useFreeShipping(cart) {
  const [offers, setOffers] = useState(null)
  const key = cart.map((line) => `${line.pid}:${line.quantity || 1}`).join(",")

  useEffect(() => {
    if (!cart.length) return setOffers([])
    let alive = true
    offersFor(cart, key).then((answer) => alive && setOffers(answer))
    return () => {
      alive = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key])

  return offers
}
